import { fillStringArrayConditionally } from './fill_string_array_conditionally';

export const generateClassName = conditions =>
  valueContainer =>
      fillStringArrayConditionally(conditions)(valueContainer)
          .join(' ');
